module.exports = __webpack_public_path__ + "static/txn_phone_c-e0e7d02422ccc0be466b97137b0ff2d6.webp";